// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1__a763c7e080e495c61913{/*!*/}.SimplePaperPodcast-cls2___91223fccf69db9e3f35{cursor:pointer;transition:background-color .15s ease}.SimplePaperPodcast-cls2___91223fccf69db9e3f35:hover{background:#fafbfc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1__a763c7e080e495c61913",
	"cls2": "SimplePaperPodcast-cls2___91223fccf69db9e3f35 SimplePaperPodcast-cls1__a763c7e080e495c61913"
};
export default ___CSS_LOADER_EXPORT___;
